import { CompanyInfoContext } from "@bokio/mobile-web-shared/core/contexts/CompanyInfoContext/CompanyInfoContext";

import { useTopLevelUser } from "../TopLevelUserContext/useTopLevelUser";

import type { FC, PropsWithChildren } from "react";

export const CompanyInfoContextProvider: FC<PropsWithChildren> = ({ children }) => {
	const { companyInfo, reloadCompanyInfo, isLoadingCompany } = useTopLevelUser();

	return (
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		<CompanyInfoContext value={{ companyInfo: companyInfo!, reloadCompanyInfo, isLoading: isLoadingCompany }}>
			{children}
		</CompanyInfoContext>
	);
};
